"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var mediaQueries_1 = require("../utils/mediaQueries");
var Sidebar_1 = require("../components/Sidebar");
/// from https://usehooks-ts.com/react-hook/use-media-query
function useMediaQuery(_a) {
    var device = _a.device, filter = _a.filter;
    var isSidebarOpen = (0, Sidebar_1.useSidebarState)().isSidebarOpen;
    var query = (0, mediaQueries_1.getMediaQueryStrings)(isSidebarOpen)[device][filter];
    var getMatches = function (query) {
        // Prevents SSR issues
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        return false;
    };
    var _b = (0, react_1.useState)(getMatches(query)), matches = _b[0], setMatches = _b[1];
    function handleChange() {
        setMatches(getMatches(query));
    }
    (0, react_1.useEffect)(function () {
        var matchMedia = window.matchMedia(query);
        // Triggered at the first client-side load and if query changes
        handleChange();
        // Listen matchMedia
        if (matchMedia.addListener) {
            matchMedia.addListener(handleChange);
        }
        else {
            matchMedia.addEventListener('change', handleChange);
        }
        return function () {
            if (matchMedia.removeListener) {
                matchMedia.removeListener(handleChange);
            }
            else {
                matchMedia.removeEventListener('change', handleChange);
            }
        };
    }, [query]);
    return matches;
}
exports.default = useMediaQuery;
